export default "__VITE_ASSET__4X3X3tEf__"